import { styled } from 'baseui'
import { FlexCenter, FlexCenterY } from '@/shared/theme/styled-components'

export const ModalOverrides = {
  Dialog: {
    style: () => ({
      borderRadius: '2rem',
      overflow: 'hidden',
    }),
  },
}

export const HeaderContainer = styled(FlexCenterY, {
  padding: '0.5rem 1rem',
  alignItems: 'flex-start',
})

export const StyledIcon = styled('img', () => ({
  marginRight: '0.45rem',
  width: '1.5rem',
  height: '1.5rem',
}))

export const TitleText = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  marginRight: 0,
  marginLeft: '0.5rem',
  fontSize: '1.2rem',
  fontWeight: '600',
  color: $theme.colors.textHeading,
}))

export const OptionsContainer = styled('div', () => ({
  display: 'flex',
  justifyContent: 'space-around',
  padding: '0.25rem 0',
}))

export const OptionCardStyled = styled(FlexCenter, ({ $theme }) => ({
  width: '8rem',
  height: '7.5rem',
  border: `0.1rem solid ${$theme.colors.borderSoft}`,
  borderRadius: '0.5rem',
  flexDirection: 'column',
  cursor: 'pointer',
  transition: 'border-color 0.3s ease',
  ':hover': {
    border: `0.25rem solid ${$theme.colors.primaryAlt}`,
    '--icon-color': $theme.colors.primary400,
  },
}))

export const OptionIconWrapper = styled(FlexCenter, ({ $theme }) => ({
  width: '2.8rem',
  height: '2.8rem',
  marginBottom: '0.85rem',
  color: `var(--icon-color, ${$theme.colors.iconMuted})`,
  transition: 'color 0.3s ease',
  '& svg': {
    width: '100%',
    height: '100%',
    fill: 'currentColor',
  },
}))

export const OptionText = styled('span', ({ $theme }) => ({
  fontSize: '1.2rem',
  color: $theme.colors.textHeading,
}))

export const ButtonsContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0.75rem',
})

export const CancelButtonOverrides = {
  BaseButton: {
    style: ({ $theme }) => ({
      width: 'calc(50% - 0.5rem)',
      backgroundColor: $theme.colors.white,
      color: $theme.colors.errorInput,
      border: `0.1rem solid ${$theme.colors.errorInput}`,
      borderRadius: '1rem',
      ':hover': {
        backgroundColor: $theme.colors.errorInput,
        color: $theme.colors.white,
      },
    }),
  },
}

export const ConfirmButtonOverrides = {
  BaseButton: {
    style: ({ $theme }) => ({
      width: 'calc(50% - 0.5rem)',
      backgroundColor: $theme.colors.white,
      color: $theme.colors.primary400,
      border: `0.1rem solid ${$theme.colors.primaryAlt}`,
      borderRadius: '1rem',
      ':hover': {
        backgroundColor: $theme.colors.primary400,
        color: $theme.colors.white,
      },
    }),
  },
}
